var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_RosterRecordForm_form_slide_dialog_selectSenderTitle"
      ),
      width: "600",
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: {
                curStep: _vm.curStep,
                items: _vm.stepper,
                backgroundColor: "white",
                contentClass: " py-3 px-8 mt-0 ",
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text--secondary text-subtitle-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_approvalApplication_form_forward_isBackApproverLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "6",
                                    sm: "4",
                                    md: "3",
                                    lg: "3",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "d-flex flex-row align-center",
                                      on: {
                                        click: function ($event) {
                                          _vm.nextNode == 0
                                            ? ((_vm.nextNode = 1),
                                              (_vm.nowNode = 0))
                                            : null
                                        },
                                      },
                                    },
                                    [
                                      _c("v-rating", {
                                        staticClass: "mx-2",
                                        attrs: {
                                          size: "25",
                                          readonly: "",
                                          "background-color": "primary ",
                                          color: "primary",
                                          "empty-icon":
                                            "radio_button_unchecked",
                                          "full-icon": "radio_button_checked",
                                          length: 1,
                                          dense: "",
                                        },
                                        model: {
                                          value: _vm.nextNode,
                                          callback: function ($$v) {
                                            _vm.nextNode = $$v
                                          },
                                          expression: "nextNode",
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_approvalApplication_form_back_nextNodeLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "6",
                                    sm: "4",
                                    md: "3",
                                    lg: "3",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "d-flex flex-row align-center",
                                      on: {
                                        click: function ($event) {
                                          _vm.nowNode == 0
                                            ? ((_vm.nowNode = 1),
                                              (_vm.nextNode = 0))
                                            : null
                                        },
                                      },
                                    },
                                    [
                                      _c("v-rating", {
                                        staticClass: "mx-2",
                                        attrs: {
                                          size: "25",
                                          readonly: "",
                                          "background-color": "primary ",
                                          color: "primary",
                                          length: 1,
                                          dense: "",
                                          "empty-icon":
                                            "radio_button_unchecked",
                                          "full-icon": "radio_button_checked",
                                        },
                                        model: {
                                          value: _vm.nowNode,
                                          callback: function ($$v) {
                                            _vm.nowNode = $$v
                                          },
                                          expression: "nowNode",
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_approvalApplication_form_back_nowNodeLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form2", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c("AutoComplete", {
                                    attrs: {
                                      isRequired: "",
                                      items: _vm.allForward,
                                      label:
                                        "label_essweb_RosterRecordForm_form_slide_dialog_senderLabel",
                                      filter: _vm.$staffFilter,
                                      chips: "",
                                      avatar: "",
                                      "two-line": "",
                                      simple: "",
                                      "hide-details": "",
                                      "deletable-chips": "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      "item-text": "staff_code",
                                      "item-value": "staff_uuid",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection.avatar",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _c("StaffAvatar", {
                                              attrs: {
                                                left: "",
                                                contentClass: "white--text",
                                                src: data.item.staff_avatar,
                                                staff_name:
                                                  data.item.preferred_name,
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.preferred_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.avatar",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _c("StaffAvatar", {
                                              attrs: {
                                                size: "36",
                                                src: data.item.staff_avatar,
                                                staff_name:
                                                  data.item.preferred_name,
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.title",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "text-body-2" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item.preferred_name
                                                    )
                                                  ) + " "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text--secondary text-caption-xs",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.item.staff_code
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.subtitle",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  data.item.job_post_name
                                                )
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.curSender,
                                      callback: function ($$v) {
                                        _vm.curSender = $$v
                                      },
                                      expression: "curSender",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                okBtn:
                  _vm.stepper.length == _vm.curStep && _vm.curStep != 0
                    ? true
                    : false,
                step: _vm.stepper.length == _vm.curStep ? false : true,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: function ($event) {
                  _vm.curStep = _vm.curStep + 1
                },
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                ok: _vm.toSubmit,
                cancel: _vm.closeDialog,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }